import type { PlacementRect } from '../core/types';

/**
 * Logical (game-space) layout constants. The game renders at a fixed logical
 * resolution and Phaser's Scale.FIT maps it to the device, preserving aspect
 * (letterboxed) so nothing stretches when the viewport changes.
 *
 * iPad Pro 11" (2024) logical landscape points are ~1194 x 834.
 */
export const GAME_WIDTH = 1194;
export const GAME_HEIGHT = 834;

/** Artwork canvas backing resolution (square). Independent of viewport size. */
export const ARTWORK_PIXELS = 1024;

/** Height reserved for the control bar along the bottom. */
export const CONTROL_BAR_HEIGHT = 176;

/** Compute the square artwork placement rect (game space), centered above the bar. */
export function computeArtworkRect(): PlacementRect {
  const available = GAME_HEIGHT - CONTROL_BAR_HEIGHT;
  const side = Math.min(available, GAME_WIDTH) - 24; // small margin
  const x = (GAME_WIDTH - side) / 2;
  const y = (available - side) / 2 + 8;
  return { x, y, width: side, height: side };
}
